import {UIButton} from "./Tools/Base/UIButton";
import {UISprite} from "./Tools/Base/UISprite";
import {UIAttention} from "./UIAttention";
import {Core} from "../Base/Core";
import {UILabeledIcon} from "./Tools/Base/UILabeledIcon";

export class SlotsButton extends UIButton {
    constructor() {
        super();
        this.back = this.addChild(new UISprite("slots/slots-ico3"));
        this.label = this.addChild(new UILabeledIcon({
            backgroundAlpha: 0.5
        }));
        this.attention = this.addChild(new UIAttention(() => {
            if (!Core.Player.Initialized) return false;
            return Core.Player.PlanetsSave.collection.length >= Core.GameData.Slots.availableFromCollectionSize && !Core.Player.Timers.SlotsOpened;
        }));
        this.on("pointertap", () => {
            Core.Player.PlanetsSave.TutorSave.spins = true;
            Core.UI.tutorial.HideObjectHand(this);
            Core.Player.Timers.SlotsOpened = true;
            Core.UI.slots.Show();
            this.attention.SetActive(false);
        });
        this._initTapHighlight(this.back);
    }

    Update() {
        this.SetActive(Core.Player.PlanetsSave.collection.length >= Core.GameData.Slots.availableFromCollectionSize);
        this.label.label = Core.Player.SpinsNumber;
        this.attention.Update();
        if (Core.Player.PlanetsSave.TutorSave.step === 6 || (Core.Player.PlanetsSave.TutorSave.step === 7 && !Core.UI.slots.Active)) {
            if (this.Active && Core.UI.tutorial.activeObject !== this) {
                console.log("SLOTS TUTORIAL", Core.UI.tutorial.activeObject);
                Core.UI.tutorial.ShowObjectHand(this);
            }
        }
    }

    fitLayout(parentRect) {
        this.position.copyFrom(parentRect);

        let rect = parentRect.clone();
        rect.x = rect.y = 0;

        this.back.fitRect(rect);

        let labelRect = rect.clone().pad(-rect.width * 0.1, -rect.height * 0.35);
        labelRect.y = rect.height * 0.8;
        this.label.fitLayout(labelRect);

        this.attention.fitLayout(new PIXI.Rectangle(rect.width * 0.15, rect.height * 0.15, 1, 1));
    }

    SetActive(value) {
        super.SetActive(value);
    }
}
